import { render } from "./DeliveryPricesSettings.vue?vue&type=template&id=7a253b91"
import script from "./DeliveryPricesSettings.vue?vue&type=script&lang=js"
export * from "./DeliveryPricesSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__